import { createSelector } from 'reselect';

export const smartlinkParameterSelector = state => state.entities.smartlinkParameters;

export const selectSmartLinkParameters = createSelector(smartlinkParameterSelector, state => {
  return Object.values(state?.toJS());
});

export const selectSmartLinkParametersByRelayControllerId = relayControllerId =>
  createSelector(selectSmartLinkParameters, state => {
    const params = state?.find(params => {
      return params.relay_controller === relayControllerId;
    });

    return params;
  });
